import React from 'react'

const Manual_acumulacion_canje_expiracion_puntos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Acumulación, canje y expiración de puntos
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Conoce cómo configurar la acumulación, canje y expiración de puntos dentro del programa de lealtad de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Acumulacion_canje_y_expiracion_de_puntos__xMmRaxDAT9eMwlpy3iwiIQ?as=scrollable"
          className="scribe-iframe-general-100"
          width="100%"
          height="8000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_acumulacion_canje_expiracion_puntos
